import { GlobalStatus } from "@gtpl/shared-models/common-models";

export class DomesticSaleDetailedViewReq {
    domesticSaleOrderNo?:string;


    constructor(
        domesticSaleOrderNo?:string,


    ) {

        this.domesticSaleOrderNo = domesticSaleOrderNo;
    }
}